import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AnalyticsState } from "./types";
import { trackEvent } from "./action";

export const initialState: AnalyticsState = {
  sessionId: "",
  isLoading: false,
  apiKey: "",
};

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    initializeAnalytics(
      state,
      action: PayloadAction<{ apiKey: string; sessionId: string }>
    ) {
      state.sessionId = action.payload.sessionId;
      state.apiKey = action.payload.apiKey;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(trackEvent.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(trackEvent.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(trackEvent.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const analyticsActions = analyticsSlice.actions;

export default analyticsSlice;
